module.exports = __webpack_public_path__ + "img/docx.482bed63.svg";